import React from 'react';

import { Container, WrapperFullHeight } from './styles';
import FooterWrapper from '../../../../components/FooterWrapper';
import { Button } from '../../../../components';
import { usePlatformContext } from '../../../../contexts/PlatformContext';
import { Conclusion } from '../../../../components/Icons/Conclusion';
import { useServiceContext } from '../../../../contexts/ServiceContext';
import { Page, useExecutiveCheckupRouter } from '../../router/context';

type AppointmentConclusionProps = {
  isFirstAppointment: boolean;
  productId: string;
  token: string;
};

export const AppointmentConclusion = ({
  isFirstAppointment = false,
  productId = '',
  token = ''
}: AppointmentConclusionProps) => {
  const { setIsSchedulerOpen, clearData } = usePlatformContext();
  const { navigate, setHistory } = useExecutiveCheckupRouter();
  const { selectedService: service, setSeletedService: setService } = useServiceContext();

  return (
    <Container>
      <WrapperFullHeight>
        <Conclusion />
        <h1 className="title">Agendamento realizado com sucesso!</h1>
        <p className="subtitle">
          {isFirstAppointment
            ? 'As informações do agendamento, preparo e protocolos foram enviados para o seu e-mail.'
            : 'As informações do agendamento foram enviadas para o seu e-mail.'}
        </p>
        <p className="subtitle" style={{ marginTop: '20px' }}>
          Para consultar seu agendamento na plataforma use o código abaixo:
        </p>
        <p className="code">{token}</p>
      </WrapperFullHeight>
      <FooterWrapper>
        <Button
          title="Voltar para home"
          onClick={() => {
            clearData();
            setIsSchedulerOpen(false);
          }}
        />
        {service.products.length > 1 && (
          <Button
            title="Agendar outro profissional"
            secondary
            onClick={() => {
              if (service.products.length > 1) {
                setService(service => ({
                  ...service,
                  products: service.products.filter(item => item.id !== productId)
                }));

                setHistory([]);

                navigate(Page.PRODUCT_LIST);
              }
            }}
          />
        )}
      </FooterWrapper>
    </Container>
  );
};
